$('.ask-confirmation').click((e) =>
  confirm(
    e.currentTarget.dataset.confirmationMessage
      ? e.currentTarget.dataset.confirmationMessage
      : 'Are you sure?'
  )
);

$('.alert-dismissible').click(e => $(e.currentTarget).fadeOut(1000));

$("body").on("click", ".no-wrap-list.toggle", function(e) {
    $(this).toggleClass('active');
});

